module.exports = __webpack_public_path__ + "static/media/image6.6d52f6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nvidia/image6.png
// module id = 1183
// module chunks = 0